import { capitalize } from 'lodash';
import { nameRegex } from '@/helpers/common';

export default {
  validate: (value, { min, max }) => {
    let valid = true;

    if (!value) valid = false;
    else {
      if (value.length < min) valid = false;
      if (value.length > max) valid = false;
      if (!nameRegex.test(value)) valid = false;
    }

    return {
      valid,
      required: true,
    };
  },
  message: (fieldName, { _value_: v, min, max }) => {
    const name = capitalize(fieldName);
    if (!v) return `Please enter your ${name}.`;
    if (!nameRegex.test(v)) return `Please enter a valid ${name}. It may contain letters, spaces and hyphen.`;
    if (v.length < min) return `${name} must contain at least ${min} characters.`;
    if (v.length > max) return `${name} must contain a maximum of ${max} characters.`;
    return `Please enter a valid ${name}. It may contain letters, spaces and hyphen.`;
  },
  params: ['min', 'max'],
  computesRequired: true,
};
